// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__Nlt4B","layout":"Settings_layout__0Zumn","settings":"Settings_settings__2RnwL"};